import { useContext } from 'react';
import OrgContext from '../OrgContext';

export default function useUserOrg() {
    const orgContext = useContext(OrgContext);

    const org = orgContext?.org;
    const setOrg = orgContext?.setOrg;

    return {
        org,
        orgId: org?.id || 0,
        setOrg,
    };
}
